export const CREATE_VC_DYNAMIC_REDUCER = 'CREATE_VC_DYNAMIC_REDUCER';
export const INITIATE_INDIVIDUAL_VC_FEED_PAGE = 'INITIATE_INDIVIDUAL_VC_FEED_PAGE';

export const createVCDynamicReducer = id => ({ type: CREATE_VC_DYNAMIC_REDUCER, id });
export const initiateIndividualVCFeedPage = id => ({ type: INITIATE_INDIVIDUAL_VC_FEED_PAGE, id });
